import { render } from "./CotizacionEditable.vue?vue&type=template&id=51e5223e&scoped=true"
const script = {}

import "./CotizacionEditable.vue?vue&type=style&index=0&id=51e5223e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e5223e"]])

export default __exports__